__turbopack_context__.v({
  "container": "_0v2rBG_container",
  "emptyList": "_0v2rBG_emptyList",
});
